<template>
    <div id="main">
      <div class="cart_t">
        <div class="w1210">
          <div class="cart_top clearfix">
            <p class="c_title step3">{{orderStatus===true?'完成订单':'订单失败'}}</p>
          </div>
        </div>
      </div>
      <div class="shop_cont">
        <!--<div class=" w1210 xxts">! 温馨提示：收到货物后15天内，系统自动将相应成长值发放到您的会员账户</div>-->
        <div class="w1210 pad35 mbottom mt15">
          <div class="w1140">
            <div class="finish_m bbtom clearfix" >
              <div class="lstat_i" v-show="orderStatus">
                <img src="../assets/img/s.png">
              </div>
              <div class="lstat_i" v-show="!orderStatus">
                <img src="../assets/img/f.png">
              </div>
              <div class="fl_p">
                <p class="onum">订单号：{{serviceSheetNo}}</p>
                <p class="pstat">
                  您已成功付款：<span>{{total}}元</span>
                </p>
                <!--<p class="psinf">-->
                <!--寄送至： 上海 上海市 浦东新区 周家渡街道 浦东新区 德州路56弄1号1101室 冯毅 收 13748562258-->
                <!--</p>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import api from '../common/utils/api'
import http from 'axios'
export default {
  components: {
  },
  data () {
    // out_trade_no
    return {
      orderStatus: null,
      serviceSheetNo: '',
      total: ''
    }
  },
  methods: {
    handleMobile () {
      // window.location.href = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) ? 'https://www.baidu.com/' : 'http://news.baidu.com/'
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    GetRequest () {
      let url = window.location.search // 获取url中"?"符后的字串
      console.log('没有参数！')
      if (url.indexOf('&') !== -1) { // 判断是否有参数
        console.log('有参数！')
        console.log('window.location.search:', window.location.search)
        let str = url.substr(1) // 从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
        if (str !== null || str !== '' || str !== undefined) {
          let strs1 = str.split('&') // 用等号进行分隔 （因为知道只有一个参数 所以直接用等号进分隔 如果有多个参数 要用&号分隔 再用等号进行分隔）
          let strs2 = strs1[1].split('=')
          this.serviceSheetNo = strs2[1]
          console.log('this.serviceSheetNo:', this.serviceSheetNo)
          if (this.serviceSheetNo === 'out_trade_no') {
            alert(this.serviceSheetNo)
          }
        }
      }
    },
    submitQuerry () {
      let url = api.reservation.queryPaidStatus()
      http({
        method: 'post',
        url: url,
        params: {
          mobile: '',
          reserveSheetNo: '',
          serviceSheetNo: this.serviceSheetNo
        }
      })
        .then(res => {
          if (res.data.serviceSheetDtl && res.data.serviceSheetDtl.length) {
            let queryLists = res.data.serviceSheetDtl
            if (queryLists[0].payStatus === '未付款') {
              this.total = queryLists[0].total
              this.orderStatus = false
            } else {
              this.total = localStorage.getItem('total')
              this.orderStatus = true
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  created () {
    this.GetRequest()
    if (this.handleMobile()) {
      window.location.href = 'https://pet-service.sony.com.cn/mobilesite/#/intermediate?serviceSheetNo=' + this.serviceSheetNo
    }
    if (this.serviceSheetNo === '' || this.serviceSheetNo === null || this.serviceSheetNo === undefined) {
    } else {
      this.submitQuerry()
    }
  },
  mounted: function () {
    window.onload = () => {
      if (!this.handleMobile()) {
        setTimeout(() => {
          this.submitQuerry()
        }, 500)
      }
    }
  }
}
</script>
<style>
  @import url("../assets/css/style.css");
  @import url("../assets/css/layout.css");
  @import url("../assets/css/editcart.css");
  @import url("../assets/css/finish.css");
</style>
